import React, { useState } from "react";
import "./Bank.css";
import GradientButton from "../button/Button";
import PlainButton from "../button/PlainButton";

interface BankDetails {
  accountName: string;
  accountNumber: string;
  routingNumber: string;
  bankName: string;
  bankAddress: string;
  swiftCode?: string;
}

interface BankModalProps {
  isOpen: boolean;
  onClose: () => void;
  bankDetails: BankDetails;
  onSave?: (details: BankDetails) => void; // Optional callback for saving
}

const BankModal: React.FC<BankModalProps> = ({
  isOpen,
  onClose,
  bankDetails,
  onSave,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [form, setForm] = useState<BankDetails>(bankDetails);

  // Sync form state if bankDetails change
  React.useEffect(() => {
    setForm(bankDetails);
  }, [bankDetails]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    setIsEditMode(false);
    if (onSave) onSave(form);
  };

  if (!isOpen) return null;

  return (
    <div className="bank-modal__overlay" onClick={onClose}>
      <div className="bank-modal__content" onClick={(e) => e.stopPropagation()}>
        <div className="bank-modal__header">
          <h2 className="bank-modal__title">Bank Details (USA)</h2>
          <button className="bank-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="bank-modal__details">
          <div className="bank-modal__row">
            <label>Account Name</label>
            <input
              type="text"
              name="accountName"
              value={form.accountName}
              onChange={handleChange}
              disabled={!isEditMode}
              className={!isEditMode ? "bank-modal__input--readonly" : ""}
            />
          </div>
          <div className="bank-modal__row">
            <label>Account Number</label>
            <input
              type="text"
              name="accountNumber"
              value={form.accountNumber}
              onChange={handleChange}
              disabled={!isEditMode}
              className={!isEditMode ? "bank-modal__input--readonly" : ""}
            />
          </div>
          <div className="bank-modal__row">
            <label>Routing Number</label>
            <input
              type="text"
              name="routingNumber"
              value={form.routingNumber}
              onChange={handleChange}
              disabled={!isEditMode}
              className={!isEditMode ? "bank-modal__input--readonly" : ""}
            />
          </div>
          <div className="bank-modal__row">
            <label>Bank Name</label>
            <input
              type="text"
              name="bankName"
              value={form.bankName}
              onChange={handleChange}
              disabled={!isEditMode}
              className={!isEditMode ? "bank-modal__input--readonly" : ""}
            />
          </div>
          <div className="bank-modal__row">
            <label>Bank Address</label>
            <textarea
              name="bankAddress"
              value={form.bankAddress}
              onChange={handleChange}
              disabled={!isEditMode}
              className={!isEditMode ? "bank-modal__input--readonly" : ""}
              rows={2}
            />
          </div>
          {form.swiftCode !== undefined && (
            <div className="bank-modal__row">
              <label>SWIFT Code</label>
              <input
                type="text"
                name="swiftCode"
                value={form.swiftCode}
                onChange={handleChange}
                disabled={!isEditMode}
                className={!isEditMode ? "bank-modal__input--readonly" : ""}
              />
            </div>
          )}
        </form>
        <div className="bank-modal__actions">
          {!isEditMode ? (
            <GradientButton text="Edit" onClick={() => setIsEditMode(true)} />
          ) : (
            <>
              <GradientButton text="Save" onClick={handleSave} />

              <PlainButton
                text="Cancel"
                onClick={() => {
                  setIsEditMode(false);
                  setForm(bankDetails);
                }}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BankModal;
